import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './BuyAirtime.css';

function BuyAirtime() {
  const [selectedProvider, setSelectedProvider] = useState('');
  const navigate = useNavigate();

  const handleProviderClick = (provider) => {
    setSelectedProvider(provider);
    navigate(`/buy-airtime/${provider}`);
  };

  return (
    <div className="buy-airtime-page">
      <div className="container">
        <h1>Buy Cheap Airtime</h1>
        <p className="subtitle">Buy any cheap airtime at given discount from your Money directly</p>
        
        <div className="provider-options">
          <div 
            className={`provider ${selectedProvider === 'safaricom' ? 'active' : ''}`} 
            onClick={() => handleProviderClick('safaricom')}
          >
            <div className="provider-logo safaricom-logo"></div>
            <h3>BUY SAFARICOM AIRTIME (13%)</h3>
            <p>Get 13% extra airtime when you buy Safaricom airtime.</p>
          </div>
          
          <div 
            className={`provider ${selectedProvider === 'airtel' ? 'active' : ''}`}
            onClick={() => handleProviderClick('airtel')}
          >
            <div className="provider-logo airtel-logo"></div>
            <h3>BUY AIRTEL AIRTIME</h3>
            <p>Purchase Airtel airtime at competitive rates.</p>
          </div>
          
          <div 
            className={`provider ${selectedProvider === 'telkom' ? 'active' : ''}`}
            onClick={() => handleProviderClick('telkom')}
          >
            <div className="provider-logo telkom-logo"></div>
            <h3>BUY TELKOM AIRTIME</h3>
            <p>Purchase Telkom airtime at competitive rates.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BuyAirtime;
